"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.areaReducer = exports.areaAction = exports.areaTypes = void 0;
const area_component_1 = __importDefault(require("./sub-components/area.component"));
const area_action_1 = __importDefault(require("./area.action"));
exports.areaAction = area_action_1.default;
const area_reducer_1 = __importDefault(require("./area.reducer"));
exports.areaReducer = area_reducer_1.default;
const area_types_1 = require("./area.types");
Object.defineProperty(exports, "areaTypes", { enumerable: true, get: function () { return area_types_1.areaTypes; } });
exports.default = area_component_1.default;
